import ServiceResponse from '@services/models/ServiceResponse';

async function fetchMeasurementUnits() {
  try {
    return new ServiceResponse({ data: [] });
  } catch (error) {
    return new ServiceResponse({ error });
  }
}

export default fetchMeasurementUnits;
